import React from "react";
import Plus from "../../../Layout/Icons/PlusIcon";

class Zoom extends React.Component {
  render() {
    const handleClick = (event) => {
      event.stopPropagation();
      this.props.handleZoom();
    };
    return (
      <div className="control__container">
        <div className="control__title">Zoom</div>

        <button
          className="control__button button button--canvas button--zoom"
          onClick={handleClick}
        >
          <Plus />
        </button>
      </div>
    );
  }
}

export default Zoom;
